import SchoolCodeForm from "./SchoolCodeForm";
export default SchoolCodeForm;
